import styled from 'styled-components';

import { InfoBoxThoughtView } from '../info-box/info-box-thought.style';
import { InfoBoxSpeechViewInteractive } from '../info-box/info-box-speech.style';

export const DiscussionQuestionOverride = styled.div`
  /* Override richtext and alignment properties */
  ${InfoBoxThoughtView}, ${InfoBoxSpeechViewInteractive} {
    max-width: 100%;

    p {
      text-align: left !important;
    }
  }
`;
